// src/components/LaunchingSoon.tsx
//
// Stands in for the App Store / Google Play badges until the apps are approved
// and live. Plain text on purpose: no store logos, no links, no URLs — a badge
// that points at "#" tells visitors an app is downloadable when it is not.
//
// To restore the badges at launch, swap this back for the badge links (see git
// history of Index.tsx and Footer.tsx) once VITE_APPSTORE_URL / VITE_PLAYSTORE_URL
// point at live listings.

interface LaunchingSoonProps {
  /** Localized label, e.g. t("download.launchingSoon", "Launching soon"). */
  label: string;
  className?: string;
}

export default function LaunchingSoon({ label, className = "" }: LaunchingSoonProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full border border-gray-700 px-5 py-2.5 text-sm font-semibold text-gray-200 ${className}`}
    >
      {label}
    </span>
  );
}
